'use client';

import { c as _c } from "react/compiler-runtime";
import { z } from '@repo/schema';
import { GetUserSchema } from '@repo/schema/user';
import { Toggle, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui/components';
import { cn, cva, type VariantProps } from '@repo/ui/lib/utils';
import { KitAvatar } from './avatar';
const avatarToggleVariants = cva('aspect-square bg-background p-0 dark:bg-input/30 dark:hover:bg-input/50', {
  defaultVariants: {
    variant: 'square'
  },
  variants: {
    variant: {
      rounded: 'rounded-full',
      square: 'rounded-lg'
    }
  }
});
type AvatarToggleProps = VariantProps<typeof avatarToggleVariants> & {
  isActive: boolean;
  onToggle: () => void;
  tooltipContent?: string | undefined;
  user?: z.infer<typeof GetUserSchema>;
};
export const AvatarToggle = t0 => {
  const $ = _c(20);
  const {
    isActive,
    onToggle,
    tooltipContent,
    user,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "square" : t1;
  const t2 = tooltipContent || "Toggle avatar";
  let t3;
  if ($[0] !== variant) {
    t3 = avatarToggleVariants({
      variant
    });
    $[0] = variant;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== onToggle || $[3] !== t2 || $[4] !== t3) {
    t4 = <Toggle aria-label={t2} className={t3} onClick={onToggle} variant="outline" />;
    $[2] = onToggle;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = isActive && "scale-95";
  let t6;
  if ($[6] !== t5) {
    t6 = cn("size-9", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6 || $[9] !== user || $[10] !== variant) {
    t7 = <KitAvatar className={t6} textClassName="text-xs font-medium" user={user} variant={variant} data-sentry-element="KitAvatar" data-sentry-source-file="avatar-toggle.tsx" />;
    $[8] = t6;
    $[9] = user;
    $[10] = variant;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = <TooltipTrigger render={t4} data-sentry-element="TooltipTrigger" data-sentry-source-file="avatar-toggle.tsx">{t7}</TooltipTrigger>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== tooltipContent) {
    t9 = tooltipContent && <TooltipContent side="bottom"><p className="text-sm">{tooltipContent}</p></TooltipContent>;
    $[15] = tooltipContent;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <Tooltip data-sentry-element="Tooltip" data-sentry-component="AvatarToggle" data-sentry-source-file="avatar-toggle.tsx">{t8}{t9}</Tooltip>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};